import type { CurrencyCode } from '#internal/packages/iso/4217';

export type UNIXTimeStamp = number;
export type UNIXTimeStampMs = number;
export type LanguageISOCode = string;
export type CountryISOCode = string;
export type GeoName = number;
export type ISODateString = string;
export type Euros = number;

export type EntityEvent<E> = EntityRemovedEvent<E> | EntityCreatedEvent<E> | EntityModifiedEvent<E>;

export type Prettify<T> = {
	[K in keyof T]: T[K];
} & {};

interface EntityRemovedEvent<E> {
	newItem: null;
	oldItem: E;
	ts: UNIXTimeStamp;
}

interface EntityCreatedEvent<E> {
	newItem: E;
	oldItem: null;
	ts: number;
}

interface EntityModifiedEvent<E> {
	newItem: E;
	oldItem: E;
	ts: number;
}

export enum applicationType {
	merchantDefault = 0,
	api = 1,
	widget = 2,
	backOffice = 3,
	portal = 4,
	tpv = 5,
	recurringDonation = 7,
	file = 8,
	paymentWidget = 9,
	merchantImplementation = 10,
	extra = 11,
	shopify = 12,
	custom = 13,
	legacyApi = 14,
	app = 15,
}

export interface PhysicalAddress {
	additionalInfo?: string;
	country?: CountryISOCode;
	province?: number;
	city?: string;
	street: {
		name?: string;
		type?: string;
		number?: string;
	};
	postalCode?: string;
	region?: number;
}

export interface Media {
	readonly type: string;
	readonly location: string;
}

export interface Image extends Media {
	readonly width: number;
	readonly height: number;
}

export interface VersionedImage extends Image {
	readonly versions: Record<string, Image>;
}

export const placeholderImage: VersionedImage = {
	type: 'image/png',
	location: 'https://cdn.worldcoo.com/public/img/wc-logo-v2.png',
	width: 1079,
	height: 371,
	versions: {},
};

export enum providerDonationCode {
	ecopaynet = 'EPA',
	CGP = 'CGP',
	paytef = 'PYT',
	worldineCondis = 'WCO',
	dieboldWincor = 'DWI',
	ticketmaster = 'TMA',
	mediamarkt = 'MM',
	necomplus = 'NEC',
	adyen = 'ADY',
	saima = 'SAI',
	sipay = 'SIP',
	axis = 'WAX',
	iecisa = 'IEC',
	glovo = 'GLO',
	pcComponentes = 'PCC',
	siam = 'SIA',
	dia = 'DIA',
	platanoMelon = 'PLA',
}

export const defaultCurrencyCode: CurrencyCode = 'EUR';

export interface Money {
	readonly currencyCode: CurrencyCode;
	readonly amount: number;
}

export interface Transaction {
	readonly money: Money;
	readonly time: UNIXTimeStampMs;
}

export enum touchPointType {
	merchant = 'merchant',
	worldcooApp = 'worldcooApp',
	portal = 'portal',
}
